<template>
  <f7-page class="page-bg-render">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        잘못된 접근
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-block strong>
      <p>페이지 접근 에러</p>
      <p>페이지 접근 방법이 잘 못 되었습니다.</p>
    </f7-block>
  </f7-page>
</template>
<script>
  export default {};
</script>